var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-steps",class:_vm.clazz,attrs:{"id":""}},[_vm._t("progress"),_c('span',{staticClass:"info"},[_c('label',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{class:_vm.subtitleClass},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"buttons"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }